(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gw-bulk-order"] && !Shopify.designMode) return;
  try {
    (() => {
    const DRAFT_KEY = 'gw_bulk_draft';

    function gwTier(n) {
      if (n >= 21) return 20;
      if (n >= 11) return 15;
      if (n >= 6)  return 10;
      if (n >= 5)  return 5;
      return 0;
    }

    function uuid() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      return Array.from(bytes, (byte, index) => ([4, 6, 8, 10].includes(index) ? '-' : '') + byte.toString(16).padStart(2, '0')).join('');
    }

    function safeJson(value, fallback) {
      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    }

    function cleanInteger(value) {
      const text = String(value).trim();
      if (!/^\d+$/.test(text)) return 0;
      const number = Number(text);
      return Number.isSafeInteger(number) && number >= 0 && number <= 200 ? number : 0;
    }

    function storedString(value, maxLength) {
      return typeof value === 'string' ? value.slice(0, maxLength) : '';
    }

    function readDraft() {
      try {
        const value = safeJson(sessionStorage.getItem(DRAFT_KEY), {});
        return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
      } catch (error) {
        return {};
      }
    }

    function clearDraft() {
      try {
        sessionStorage.removeItem(DRAFT_KEY);
      } catch (error) {
        return;
      }
    }

    function moneyParts(cents, precision, thousands, decimal) {
      const fixed = (Math.abs(cents) / 100).toFixed(precision);
      let [whole, fraction] = fixed.split('.');
      whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return `${cents < 0 ? '-' : ''}${whole}${precision ? decimal + fraction : ''}`;
    }

    function moneyFormatter(format) {
      const template = typeof format === 'string' && format ? format : '$' + '{' + '{amount' + '}' + '}';
      return (cents) => {
        const token = (template.match(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/) || [null, 'amount'])[1];
        const definitions = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ',']
        };
        const definition = definitions[token] || definitions.amount;
        const result = template.replace(/\{\{\s*[a-zA-Z0-9_]+\s*\}\}/, moneyParts(cents, definition[0], definition[1], definition[2]));
        return result.replace(/<[^>]*>/g, '');
      };
    }

    function emit(root, key, value) {
      root.dispatchEvent(new CustomEvent('gw:bulk', { bubbles: true, detail: { key, value } }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'gw_bulk', gw_key: key, gw_value: value });
      if (typeof window.clarity === 'function') {
        const clarityValue = typeof value === 'string' ? value : JSON.stringify(value);
        window.clarity('set', `gw_bulk_${key}`, clarityValue);
      }
    }

    function init(root) {
      if (root.dataset.gwReady === 'true') return;
      root.dataset.gwReady = 'true';

      const sizes = safeJson(root.dataset.sizes, []);
      const config = safeJson(root.dataset.config, {});
      const success = root.querySelector('[data-gw-success]');
      if (success) {
        clearDraft();
        success.focus({ preventScroll: true });
        return;
      }

      const sizeMap = new Map(sizes.map((item) => [item.size, item]));
      const form = root.querySelector('.gw-bulk__native-form');
      if (!form) return;
      const wishes = root.querySelector('[data-gw-wishes]');
      const wishesCount = root.querySelector('[data-gw-wishes-count]');
      const qtyError = root.querySelector('[data-gw-qty-error]');
      const sizeList = root.querySelector('[data-gw-sizes]');
      const nameInput = root.querySelector('[data-gw-name]');
      const emailInput = root.querySelector('[data-gw-email]');
      const companyInput = root.querySelector('[data-gw-company]');
      const phoneInput = root.querySelector('[data-gw-phone]');
      const deadlineInput = root.querySelector('[data-gw-deadline]');
      const websiteInput = root.querySelector('[data-gw-website]');
      const submit = root.querySelector('[data-gw-submit]');
      const submitLabel = root.querySelector('[data-gw-submit-label]');
      const spinner = root.querySelector('[data-gw-spinner]');
      const submitReason = root.querySelector('[data-gw-submit-reason]');
      const contactBody = root.querySelector('[data-gw-contact-body]');
      const contactRequestId = root.querySelector('[data-gw-contact-request-id]');
      const sticky = root.querySelector('[data-gw-sticky]');
      const reviewSection = root.querySelector('[data-gw-review]');
      const formatMoney = moneyFormatter(config.moneyFormat);
      const stored = readDraft();
      const storedContact = stored.contact && typeof stored.contact === 'object' && !Array.isArray(stored.contact) ? stored.contact : {};
      const storedRequestId = storedString(stored.requestId, 64);
      const state = {
        qty: stored.qty && typeof stored.qty === 'object' ? stored.qty : {},
        wishes: storedString(stored.wishes, 2000),
        shipMode: stored.shipMode === 'individual' ? 'individual' : 'one',
        deadline: storedString(stored.deadline, 10),
        contact: {
          name: storedString(storedContact.name, 200),
          email: storedString(storedContact.email, 254),
          company: storedString(storedContact.company, 200),
          phone: storedString(storedContact.phone, 100)
        },
        requestId: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(storedRequestId) ? storedRequestId : uuid(),
        submitting: false
      };
      let lastTier = 0;
      let wishesEmitted = Boolean(state.wishes.trim());
      let reviewVisible = false;
      let validationAttempted = false;

      function persist() {
        try {
          sessionStorage.setItem(DRAFT_KEY, JSON.stringify({
            qty: state.qty,
            wishes: state.wishes,
            shipMode: state.shipMode,
            deadline: state.deadline,
            contact: state.contact,
            requestId: state.requestId
          }));
        } catch (error) {
          return;
        }
      }

      function totalBoards() {
        return sizes.reduce((total, item) => total + (item.available ? cleanInteger(state.qty[item.size]) : 0), 0);
      }

      function subtotalCents() {
        return sizes.reduce((total, item) => total + (item.available ? cleanInteger(state.qty[item.size]) * Number(item.price || 0) : 0), 0);
      }

      function buildContactBody() {
        const count = totalBoards();
        const subtotal = subtotalCents();
        const tier = gwTier(count);
        const discount = Math.round(subtotal * tier / 100);
        const total = subtotal - discount;
        const currency = config.currency ? ` ${config.currency}` : '';
        const productUrl = config.productUrl ? new URL(config.productUrl, window.location.origin).href : window.location.href.split('?')[0];
        const selectedSizes = sizes
          .filter((item) => item.available && cleanInteger(state.qty[item.size]) > 0)
          .map((item) => {
            const quantity = cleanInteger(state.qty[item.size]);
            const price = Number(item.price || 0);
            return `- ${quantity} × ${item.size} | Variant ID: ${item.id} | Unit: ${formatMoney(price)} | Line subtotal: ${formatMoney(price * quantity)}`;
          });

        return [
          'BULK QUOTE REQUEST — FOR EDUARD',
          '',
          `Request ID: ${state.requestId}`,
          `Submitted: ${new Date().toISOString()}`,
          `Product: ${config.productTitle || document.title}`,
          `Product URL: ${productUrl}`,
          'Configuration: With Juice Groove; Without Rubber Feet (Double-Sided)',
          '',
          'SELECTED BOARDS',
          ...selectedSizes,
          '',
          'QUOTE ESTIMATE',
          `Total boards: ${count}`,
          `Subtotal: ${formatMoney(subtotal)}${currency}`,
          `Bulk discount: ${tier}% (-${formatMoney(discount)})`,
          `Estimated total: ${formatMoney(total)}${currency}`,
          'Taxes and any international shipping are not included.',
          '',
          'DELIVERY',
          `Shipping: ${state.shipMode === 'individual' ? 'Each board to its own recipient' : 'One address'}`,
          `Needed by: ${state.deadline || 'Not provided'}`,
          '',
          'CONTACT',
          `Name: ${state.contact.name.trim()}`,
          `Email: ${state.contact.email.trim()}`,
          `Company: ${state.contact.company.trim() || 'Not provided'}`,
          `Phone: ${state.contact.phone.trim() || 'Not provided'}`,
          '',
          'ENGRAVING WISHES',
          state.wishes.trim(),
          '',
          'ARTWORK',
          'Customer was asked to reply to Eduard’s email with the logo or artwork attached.',
          '',
          'Internal note: This is a storefront estimate. Verify current variant availability, prices, discount and shipping before sending the invoice.'
        ].join('\n');
      }

      function tierHint(count) {
        if (count < 5) return `Add ${5 - count} more to reach the 5-board minimum`;
        if (count === 5) return 'Add 1 more board → 10% off';
        if (count === 10) return 'Add 1 more board → 15% off';
        if (count === 20) return 'Add 1 more board → 20% off';
        return '';
      }

      function emailValid() {
        return emailInput.value.trim() !== '' && emailInput.validity.valid;
      }

      function deadlineValid() {
        return !deadlineInput.value || deadlineInput.validity.valid;
      }

      function blocker(count) {
        if (sizes.length !== Number(config.expectedSizes || 12) || Number(config.matchedSizes) !== Number(config.expectedSizes || 12)) return 'Size options are temporarily unavailable';
        if (count < Number(config.min || 5)) {
          const remaining = Number(config.min || 5) - count;
          return `Add ${remaining} more ${remaining === 1 ? 'board' : 'boards'}`;
        }
        if (!state.wishes.trim()) return 'Tell us what to engrave';
        if (!state.contact.name.trim()) return 'Add your name';
        if (!state.contact.email.trim()) return 'Add your email';
        if (!emailValid()) return 'Enter a valid email';
        if (!deadlineValid()) return 'Choose a date at least 7 days from today';
        return '';
      }

      function setError(element, input, message) {
        element.textContent = message;
        element.hidden = !message;
        if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
      }

      function revealAll() {
        root.querySelectorAll('[data-gw-size-row][hidden]').forEach((row) => { row.hidden = false; });
        const more = root.querySelector('[data-gw-more]');
        more.hidden = true;
        more.setAttribute('aria-expanded', 'true');
      }

      function renderEstimate(count, subtotal, tier, discount, total) {
        const empty = root.querySelector('[data-gw-estimate-empty]');
        const filled = root.querySelector('[data-gw-estimate-filled]');
        const lines = root.querySelector('[data-gw-estimate-lines]');
        empty.hidden = count > 0;
        filled.hidden = count === 0;
        lines.replaceChildren();

        if (count === 0) return;

        sizes.forEach((item) => {
          const quantity = item.available ? cleanInteger(state.qty[item.size]) : 0;
          if (!quantity) return;
          const line = document.createElement('div');
          line.className = 'gw-bulk__estimate-line';
          const name = document.createElement('span');
          name.textContent = `${quantity} × ${item.size}`;
          const each = document.createElement('span');
          each.textContent = `${formatMoney(Number(item.price))} ea`;
          const amount = document.createElement('strong');
          amount.textContent = formatMoney(Number(item.price) * quantity);
          line.append(name, each, amount);
          lines.append(line);
        });

        root.querySelector('[data-gw-subtotal-label]').textContent = `Subtotal (${count} ${count === 1 ? 'board' : 'boards'})`;
        root.querySelector('[data-gw-subtotal]').textContent = formatMoney(subtotal);
        const discountRow = root.querySelector('[data-gw-discount-row]');
        discountRow.hidden = tier === 0;
        root.querySelector('[data-gw-discount-label]').textContent = `Bulk discount — ${tier}%`;
        root.querySelector('[data-gw-discount]').textContent = `−${formatMoney(discount)}`;
        root.querySelector('[data-gw-total]').textContent = formatMoney(total);
        const hint = root.querySelector('[data-gw-tier-hint]');
        hint.textContent = tierHint(count);
        hint.hidden = !hint.textContent;
      }

      function renderPrices(tier) {
        root.querySelectorAll('[data-gw-size-row]').forEach((row) => {
          const priceWrap = row.querySelector('.gw-bulk__unit-price');
          const base = row.querySelector('[data-gw-price-base]');
          const reduced = row.querySelector('[data-gw-price-discount]');
          const price = Number(row.dataset.price || 0);
          const active = tier > 0 && row.dataset.available === 'true';
          priceWrap.classList.toggle('is-discounted', active);
          reduced.hidden = !active;
          if (active) reduced.textContent = `${formatMoney(Math.round(price * (100 - tier) / 100))} each`;
          base.textContent = `${formatMoney(price)} each`;
        });
      }

      function render() {
        const count = totalBoards();
        const subtotal = subtotalCents();
        const tier = gwTier(count);
        const discount = Math.round(subtotal * tier / 100);
        const total = subtotal - discount;

        renderPrices(tier);
        renderEstimate(count, subtotal, tier, discount, total);
        root.querySelector('[data-gw-sticky-summary]').textContent = `${count} ${count === 1 ? 'board' : 'boards'} · est. ${formatMoney(total)}`;
        sticky.hidden = false;
        sticky.dataset.active = count > 0 && !reviewVisible && !state.submitting ? 'true' : 'false';

        const reason = blocker(count);
        submit.disabled = state.submitting;
        submitReason.textContent = reason;
        submitReason.hidden = !reason;
        const sizeConfigurationError = sizes.length !== Number(config.expectedSizes || 12) || Number(config.matchedSizes) !== Number(config.expectedSizes || 12);
        const remaining = Number(config.min || 5) - count;
        const quantityMessage = sizeConfigurationError ? 'Size options are temporarily unavailable. Please contact us for a quote.' : remaining > 0 ? `Add ${remaining} more ${remaining === 1 ? 'board' : 'boards'} to reach the minimum.` : '';
        setError(qtyError, sizeList, validationAttempted || count > 0 ? quantityMessage : '');

        if (tier !== lastTier && tier > 0) emit(root, 'tier_reached', tier);
        lastTier = tier;
      }

      function syncStateFromFields() {
        state.wishes = wishes.value;
        state.deadline = deadlineInput.value;
        state.contact.name = nameInput.value;
        state.contact.email = emailInput.value;
        state.contact.company = companyInput.value;
        state.contact.phone = phoneInput.value;
        const checkedMode = form.querySelector('input[name^="gw_ship_mode_"]:checked');
        state.shipMode = checkedMode ? checkedMode.value : 'one';
      }

      function restore() {
        root.querySelectorAll('[data-gw-qty]').forEach((input) => {
          const item = sizeMap.get(input.dataset.size);
          const quantity = item && item.available ? cleanInteger(state.qty[input.dataset.size]) : 0;
          state.qty[input.dataset.size] = quantity;
          input.value = String(quantity);
          if (quantity > 0 && input.closest('[data-gw-size-row]').hidden) revealAll();
        });
        wishes.value = state.wishes;
        wishesCount.textContent = String(state.wishes.length);
        nameInput.value = state.contact.name;
        emailInput.value = state.contact.email;
        companyInput.value = state.contact.company;
        phoneInput.value = state.contact.phone;
        deadlineInput.value = state.deadline;
        state.deadline = deadlineInput.value;
        const mode = form.querySelector(`input[name^="gw_ship_mode_"][value="${state.shipMode}"]`);
        if (mode) mode.checked = true;
        persist();
        render();
      }

      function updateQuantity(input, value, source) {
        const item = sizeMap.get(input.dataset.size);
        const quantity = item && item.available ? cleanInteger(value) : 0;
        state.qty[input.dataset.size] = quantity;
        input.value = String(quantity);
        persist();
        render();
        if (source) emit(root, 'size_change', { size: input.dataset.size, quantity });
      }

      function validateVisibleFields() {
        const count = totalBoards();
        const badSizeConfiguration = sizes.length !== Number(config.expectedSizes || 12) || Number(config.matchedSizes) !== Number(config.expectedSizes || 12);
        const remaining = Number(config.min || 5) - count;
        setError(qtyError, sizeList, badSizeConfiguration ? 'Size options are temporarily unavailable. Please contact us for a quote.' : remaining > 0 ? `Add ${remaining} more ${remaining === 1 ? 'board' : 'boards'} to reach the minimum.` : '');
        setError(root.querySelector('[data-gw-wishes-error]'), wishes, state.wishes.trim() ? '' : 'Tell us what to engrave.');
        setError(root.querySelector('[data-gw-name-error]'), nameInput, state.contact.name.trim() ? '' : 'Add your name.');
        let emailMessage = '';
        if (!state.contact.email.trim()) emailMessage = 'Add your email.';
        else if (!emailValid()) emailMessage = 'Enter a valid email address.';
        setError(root.querySelector('[data-gw-email-error]'), emailInput, emailMessage);
        setError(root.querySelector('[data-gw-deadline-error]'), deadlineInput, deadlineValid() ? '' : 'Choose a date at least 7 days from today.');
        return !blocker(count);
      }

      function focusFirstInvalidField() {
        const target = [sizeList, wishes, deadlineInput, nameInput, emailInput]
          .find((field) => field.getAttribute('aria-invalid') === 'true');
        if (!target) return;
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        window.requestAnimationFrame(() => target.focus({ preventScroll: true }));
      }

      function setSubmitting(active) {
        state.submitting = active;
        form.setAttribute('aria-busy', active ? 'true' : 'false');
        submitLabel.textContent = active ? 'Sending…' : 'Request a quote';
        spinner.hidden = !active;
        render();
      }

      root.querySelectorAll('[data-gw-size-row]').forEach((row) => {
        const input = row.querySelector('[data-gw-qty]');
        row.querySelectorAll('button:disabled, input:disabled').forEach((control) => { control.dataset.wasDisabled = 'true'; });
        row.querySelector('[data-gw-dec]').addEventListener('click', () => updateQuantity(input, Math.max(0, cleanInteger(input.value) - 1), true));
        row.querySelector('[data-gw-inc]').addEventListener('click', () => updateQuantity(input, Math.min(200, cleanInteger(input.value) + 1), true));
        input.addEventListener('input', () => {
          state.qty[input.dataset.size] = cleanInteger(input.value);
          persist();
          render();
        });
        input.addEventListener('change', () => updateQuantity(input, input.value, true));
        input.addEventListener('blur', () => updateQuantity(input, input.value, false));
      });

      root.querySelector('[data-gw-more]').addEventListener('click', revealAll);

      wishes.addEventListener('input', () => {
        state.wishes = wishes.value;
        wishesCount.textContent = String(wishes.value.length);
        setError(root.querySelector('[data-gw-wishes-error]'), wishes, validationAttempted && !state.wishes.trim() ? 'Tell us what to engrave.' : '');
        if (state.wishes.trim() && !wishesEmitted) {
          wishesEmitted = true;
          emit(root, 'wishes_filled', true);
        }
        if (!state.wishes.trim()) wishesEmitted = false;
        persist();
        render();
      });

      form.querySelectorAll('input[name^="gw_ship_mode_"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          state.shipMode = radio.value;
          persist();
        });
      });

      [nameInput, emailInput, companyInput, phoneInput, deadlineInput].forEach((input) => {
        input.addEventListener('input', () => {
          syncStateFromFields();
          if (input === nameInput) setError(root.querySelector('[data-gw-name-error]'), nameInput, validationAttempted && !state.contact.name.trim() ? 'Add your name.' : '');
          if (input === emailInput) {
            const message = !validationAttempted || emailValid() ? '' : state.contact.email.trim() ? 'Enter a valid email address.' : 'Add your email.';
            setError(root.querySelector('[data-gw-email-error]'), emailInput, message);
          }
          if (input === deadlineInput) setError(root.querySelector('[data-gw-deadline-error]'), deadlineInput, validationAttempted && !deadlineValid() ? 'Choose a date at least 7 days from today.' : '');
          persist();
          render();
        });
      });

      nameInput.addEventListener('blur', () => setError(root.querySelector('[data-gw-name-error]'), nameInput, nameInput.value.trim() ? '' : 'Add your name.'));
      emailInput.addEventListener('blur', () => {
        const message = !emailInput.value.trim() ? 'Add your email.' : emailValid() ? '' : 'Enter a valid email address.';
        setError(root.querySelector('[data-gw-email-error]'), emailInput, message);
      });

      root.querySelector('[data-gw-review-button]').addEventListener('click', () => {
        reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      form.addEventListener('submit', (event) => {
        syncStateFromFields();
        persist();
        validationAttempted = true;
        if (!validateVisibleFields()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusFirstInvalidField();
          return;
        }
        if (websiteInput.value.trim()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        contactRequestId.value = state.requestId;
        contactBody.value = buildContactBody();
        setSubmitting(true);
        emit(root, 'submit', totalBoards());
      });

      const minimumDate = new Date();
      minimumDate.setHours(12, 0, 0, 0);
      minimumDate.setDate(minimumDate.getDate() + 7);
      deadlineInput.min = [minimumDate.getFullYear(), String(minimumDate.getMonth() + 1).padStart(2, '0'), String(minimumDate.getDate()).padStart(2, '0')].join('-');
      const christmasNote = root.querySelector('[data-gw-christmas-note]');
      const christmasCutoff = new Date(2026, 11, 5, 23, 59, 59);
      if (new Date() > christmasCutoff) christmasNote.hidden = true;

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          reviewVisible = entries.some((entry) => entry.isIntersecting);
          if (reviewVisible) sticky.dataset.active = 'false';
          else if (totalBoards() > 0 && !state.submitting) sticky.dataset.active = 'true';
        }, { threshold: 0.15 });
        observer.observe(reviewSection);
      }

      restore();
      const serverErrors = root.querySelector('[data-gw-server-errors]');
      if (serverErrors) serverErrors.focus({ preventScroll: true });
    }

    function boot(scope) {
      const target = scope && scope.querySelectorAll ? scope : document;
      target.querySelectorAll('[data-gw-bulk]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
    else boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gw-configurator"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new WeakSet();
  const memory = new Map();
  let serial = 0;
  const html = document.documentElement;
  const text = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  const value = (root, selector) => root.querySelector(selector)?.value?.trim() || '';
  const checked = (root, selector) => !!root.querySelector(selector)?.checked;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerBottom() {
    const header = document.querySelector('.shopify-section--header');
    return Math.max(0, header ? header.getBoundingClientRect().bottom : 0);
  }

  function track(action, step, extra) {
    const detail = Object.assign({ action, step }, extra || {});
    document.dispatchEvent(new CustomEvent('gw:config', { detail }));
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'gw_config', gw_action: action, gw_step: step });
    if (window.clarity) window.clarity('set', 'gw_config', step + ':' + action);
  }

  function init(settings) {
    if (instances.has(settings)) return;
    const scope = settings.closest('.shopify-section');
    const eng = scope?.querySelector('[data-gw-eng][data-gw-mode="block"]');
    const size = scope?.querySelector('[data-gw-size]');
    const extras = scope?.querySelector('[data-gw-extras]');
    if (!eng || !size || !extras) return;
    instances.add(settings);
    const l = JSON.parse(settings.textContent);
    const key = settings.dataset.productId;
    // gw-size draws groove and feet tiles for every board; its config says
    // which of them the product actually carries as a variant option (0 = none).
    let sizeConfig = {};
    try { sizeConfig = JSON.parse(size.dataset.config || '{}'); } catch (error) { sizeConfig = {}; }
    const hasGroove = !('posGroove' in sizeConfig) || Number(sizeConfig.posGroove) > 0;
    const hasFeet = !('posFeet' in sizeConfig) || Number(sizeConfig.posFeet) > 0;
    const state = memory.get(key) || { open: { personalization: true, size: true, details: true } };
    memory.set(key, state);
    scope.classList.add('gw-config-scope');

    const steps = new Map();
    const engravingToggle = eng.querySelector('[data-gw-toggle]');
    let plainChoice, hero, panel, panelHome, plain, saveButton, saveLink, saveWrap, thumb, lastThumb = '';
    let updating = false, queued = 0, settleTimer = 0, holdTimer = 0, busyUntil = 0;
    // "No engraving" is a choice the customer makes (the radio, or Continue
    // with nothing picked) — never a default. Until then nothing in the
    // styles row is selected and the summary invites the choice.
    let plainDecided = false;
    // The on-board preview is requested once per engraving session, on the
    // first text, using the pre-selected placement.
    let previewAsked = false;
    // The email box under the editor, once the customer has asked for it.
    let saveWanted = false;
    const HOLD_MS = 20000;

    /* ------------------------------------------------ engraving popup */
    // The same stamp the popup writes for itself after a show: the nudge
    // rests for popup_days. Used when the customer has answered the question.
    function restPopup() {
      try { window.localStorage.setItem('gw_pop_seen', String(Date.now())); } catch (error) { /* storage blocked: the popup then relies on its own checks */ }
    }
    // Invisible, non-modal: never shown, only exists to be found by the
    // popup's "another dialog is up" check while the customer is busy here.
    const hold = document.createElement('dialog');
    hold.className = 'gw-config__hold';
    hold.setAttribute('aria-hidden', 'true');
    hold.tabIndex = -1;
    scope.append(hold);
    function touch() {
      if (!hold.hasAttribute('open')) hold.setAttribute('open', '');
      window.clearTimeout(holdTimer);
      holdTimer = window.setTimeout(() => hold.removeAttribute('open'), HOLD_MS);
    }

    /* ---------------------------------------------------------------- helpers */
    function setCheckbox(input, on) {
      if (!input || input.checked === on) return;
      input.checked = on;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function stepOf(node) {
      for (const step of steps.values()) if (step.root.contains(node)) return step;
      return null;
    }

    function follows(step, node) {
      return !!(step.root.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING) && !step.root.contains(node);
    }

    /* Rule 4 guard: with the editor on, non-custom, is there text to engrave? */
    function engravingIssue() {
      if (!checked(eng, '[data-gw-toggle]')) return '';
      const custom = checked(eng, '[data-gw-custom]');
      const field = eng.querySelector(custom ? '[data-gw-desc]' : '[data-gw-in1]');
      const fileError = eng.querySelector('[data-gw-file-err]');
      if (custom && fileError && !fileError.hidden) return fileError.textContent;
      if (!field?.value.trim()) return custom ? l.describe_design : l.enter_text;
      if (!custom && field.validity && !field.validity.valid) return field.validationMessage || l.enter_text;
      return '';
    }

    function reportEngraving() {
      const issue = engravingIssue();
      const message = eng.querySelector('[data-gw-config-error]');
      if (message) { message.hidden = !issue; if (issue) text(message, issue); }
      if (!issue) return true;
      const custom = checked(eng, '[data-gw-custom]');
      const field = eng.querySelector(custom ? '[data-gw-desc]' : '[data-gw-in1]');
      if (field && !field.value.trim()) {
        const error = eng.querySelector('[data-gw-err]');
        if (error) { error.hidden = false; }
        field.focus({ preventScroll: true });
        field.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'instant' : 'smooth' });
      } else if (field) field.reportValidity();
      return false;
    }

    /* ------------------------------------------------- open / close engine */
    // A closed step says "Change" — except personalization while nothing has
    // been chosen there yet, which says "Choose".
    function actionLabel(step) {
      return step.id === 'personalization' && !checked(eng, '[data-gw-toggle]') && !plainDecided ? l.choose : l.change;
    }
    function apply(step, open) {
      state.open[step.id] = open;
      step.root.classList.toggle('gw-config-step--open', open);
      step.button.setAttribute('aria-expanded', String(open));
      text(step.actionText, open ? '' : actionLabel(step));
      step.body.inert = !open;
      step.body.setAttribute('aria-hidden', String(!open));
      if (step.id === 'personalization') movePreview(!open);
    }

    /* Instant, invisible: adjust the scroll position by exactly the height
       the page lost above `anchor`, so what the customer is touching or
       reading stays where it was. Verified after the fact — if the anchor did
       not come back (a sticky context), the adjustment is undone. */
    function withoutAnchoring(fn) {
      html.classList.add('gw-config-no-anchor');
      try { fn(); } finally { requestAnimationFrame(() => html.classList.remove('gw-config-no-anchor')); }
    }

    /* While one of our own animations (a step opening or closing, a scroll
       we started) is running, the page is mid-flight: rule 2 must not read
       that as "the customer scrolled past". */
    function quiet(ms) { busyUntil = Math.max(busyUntil, performance.now() + ms); }

    /* Continue / No engraving: the editor above the size step animates shut
       while the scroll position is adjusted every frame, so the size heading
       glides from wherever it is straight up to the header. Correct on every
       frame, so nothing ever sits above the viewport half-way. */
    function glide(node, duration = 300, endTop = headerBottom() + 12) {
      if (reducedMotion()) {
        window.scrollBy({ top: node.getBoundingClientRect().top - endTop, left: 0, behavior: 'instant' });
        return;
      }
      const startTop = node.getBoundingClientRect().top;
      const t0 = performance.now();
      quiet(duration + 200);
      function frame(now) {
        const t = Math.min(1, (now - t0) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        const want = startTop + (endTop - startTop) * eased;
        const current = node.getBoundingClientRect().top;
        if (Math.abs(current - want) > 0.5) window.scrollBy({ top: current - want, left: 0, behavior: 'instant' });
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function collapse(step, options = {}) {
      if (!state.open[step.id]) return;
      const anchor = options.anchor && options.anchor.isConnected ? options.anchor : null;
      if (!options.instant) { quiet(340); apply(step, false); track('close', step.id, { reason: options.reason || 'manual' }); return; }
      withoutAnchoring(() => {
        step.root.classList.add('gw-config-step--instant');
        const before = anchor ? anchor.getBoundingClientRect().top : 0;
        apply(step, false);
        void step.root.offsetHeight;
        if (anchor) {
          const after = anchor.getBoundingClientRect().top;
          const delta = after - before;
          if (Math.abs(delta) > 0.5) {
            const y0 = window.scrollY;
            window.scrollBy({ top: delta, left: 0, behavior: 'instant' });
            const moved = window.scrollY - y0;
            // An in-flow anchor rides the scroll by exactly -moved. If it did
            // not, scrolling cannot hold it (sticky/fixed context): undo.
            // A clamped scroll (page top reached) keeps what it could.
            if (Math.abs((after - moved) - anchor.getBoundingClientRect().top) > 1) window.scrollBy({ top: -moved, left: 0, behavior: 'instant' });
          }
        }
        requestAnimationFrame(() => step.root.classList.remove('gw-config-step--instant'));
      });
      track('close', step.id, { reason: options.reason || 'auto' });
    }

    function expand(step, options = {}) {
      if (state.open[step.id]) return;
      if (options.instant) {
        step.root.classList.add('gw-config-step--instant');
        apply(step, true);
        void step.root.offsetHeight;
        requestAnimationFrame(() => step.root.classList.remove('gw-config-step--instant'));
      } else { quiet(340); apply(step, true); }
      track('open', step.id, { reason: options.reason || 'manual' });
    }

    /* Bring a heading just under the sticky header, only when it is not
       comfortably on screen already. */
    function reveal(node, delay = 0) {
      window.setTimeout(() => {
        const top = headerBottom();
        const rect = node.getBoundingClientRect();
        scope.style.setProperty('--gw-config-scroll-offset', (top + 12) + 'px');
        if (rect.top >= top && rect.top <= window.innerHeight * 0.55) return;
        const target = Math.max(0, window.scrollY + rect.top - top - 12);
        quiet(900);
        window.scrollTo({ top: target, behavior: reducedMotion() ? 'instant' : 'smooth' });
      }, delay);
    }

    /* An in-flow element that moves with the page when content above it
       shrinks. Fixed/sticky things (the sticky buy bar) do not, so they hand
       over to the block after the last step. */
    function fallbackAnchor() {
      return scope.querySelector('.product-info__block-item[data-block-type="payment-terms"], .product-info__block-item[data-block-type="buy-buttons"]')
        || extras.closest('.product-info__block-item') || extras;
    }
    function inFlow(node) {
      for (let n = node; n && n !== scope; n = n.parentElement) {
        const position = window.getComputedStyle(n).position;
        if (position === 'fixed' || position === 'sticky') return false;
      }
      return true;
    }

    /* Rule 1: the customer touched something after this step. A tap on the
       recap is the opposite — going back — so it never closes anything. */
    function moveOn(target) {
      if (!scope.contains(target) || target.closest('.gw-config__recap')) return;
      const near = target.closest('label, button, summary, a, input, textarea, select') || target;
      const anchor = inFlow(near) ? near : fallbackAnchor();
      steps.forEach(step => {
        if (step.id !== 'personalization') return;   // 2026-09-12: rule 1 applies to the engraving step only; size and details stay open until tapped
        if (!state.open[step.id] || !follows(step, target)) return;
        collapse(step, { instant: true, anchor, reason: 'move-on' });
      });
    }

    /* Rule 2: the step scrolled entirely above the viewport. */
    function settled() {
      if (performance.now() < busyUntil) {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settled, busyUntil - performance.now() + 60);
        return;
      }
      const top = headerBottom();
      const anchor = fallbackAnchor();
      const active = document.activeElement;
      const typing = !!active && active.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable]');
      steps.forEach(step => {
        if (!state.open[step.id] || (typing && step.root.contains(active))) return;
        if (step.root.getBoundingClientRect().bottom < top - 4) collapse(step, { instant: true, anchor, reason: 'scrolled-past' });
      });
    }
    function onScroll() { window.clearTimeout(settleTimer); settleTimer = window.setTimeout(settled, 180); }
    // 2026-09-12: rule 2 is off — nothing closes because the page was scrolled. settled()/onScroll stay defined, unused.
    void onScroll;

    /* --------------------------------------------------- preview movement */
    function movePreview(closed) {
      if (!hero) return;
      if (panel) {
        if (closed && panel.parentNode !== hero) hero.prepend(panel);
        if (!closed && panel.parentNode !== panelHome.parentNode) panelHome.after(panel);
      }
      if (closed && checked(eng, '[data-gw-toggle]') && !checked(eng, '[data-gw-custom]') && !engravingIssue()) {
        // Closing the editor also accepts its currently selected placement, which is what reveals the board.
        eng.querySelector('[data-gw-loc-choice]:checked')?.click();
      }
      updateHero();
    }

    function updateHero() {
      if (!hero) return;
      const plainImage = plain.querySelector('img');
      const groove = hasGroove ? size.querySelector('[data-gw-groove]:checked') : null;
      const plainSource = photo?.getAttribute(groove && /^Without\b/i.test(groove.value) ? 'data-src-without-groove' : 'data-src-with-groove')
        || photo?.getAttribute('data-src') || photo?.getAttribute('src');
      if (plainImage && plainSource && plainImage.getAttribute('src') !== plainSource) plainImage.src = plainSource;
      const previewHome = panelHome?.parentElement;
      if (previewHome && previewHome.clientWidth > 0) {
        const homeStyle = window.getComputedStyle(previewHome);
        const contentWidth = previewHome.clientWidth - (parseFloat(homeStyle.paddingLeft) || 0) - (parseFloat(homeStyle.paddingRight) || 0);
        if (contentWidth > 0) {
          const width = contentWidth + 'px';
          if (hero.style.getPropertyValue('--gw-config-preview-width') !== width) hero.style.setProperty('--gw-config-preview-width', width);
        }
      }
      const on = checked(eng, '[data-gw-toggle]');
      const custom = checked(eng, '[data-gw-custom]');
      const issue = on ? engravingIssue() : '';
      const editing = !!state.open.personalization;
      const board = !editing && on && !custom && !issue && !!panel && panel.parentNode === hero && !panel.hidden;
      hero.classList.toggle('gw-config__hero--plain', !board);
      plain.hidden = board || editing;
      // gw-engraving offers the email box from two characters of text on.
      if (saveButton) saveButton.hidden = !board || value(eng, '[data-gw-in1]').length < 2;
    }

    function updateThumb() {
      const source = eng.querySelector('svg[data-gw-pv]');
      const on = checked(eng, '[data-gw-toggle]');
      const custom = checked(eng, '[data-gw-custom]');
      const show = on && !custom && !!value(eng, '[data-gw-in1]') && source && !source.hasAttribute('hidden') && !source.classList.contains('gw-eng__pv--ghost');
      if (!show) { thumb.hidden = true; return; }
      const signature = source.innerHTML;
      if (signature !== lastThumb) {
        const clone = source.cloneNode(true);
        ['hidden', 'class', 'style', 'data-gw-pv', 'aria-hidden'].forEach(name => clone.removeAttribute(name));
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('focusable', 'false');
        thumb.replaceChildren(clone);
        lastThumb = signature;
      }
      thumb.hidden = false;
    }

    /* ------------------------------------------------------- step builder */
    function makeStep(id, root, nodes, extra = {}) {
      root.classList.add('gw-config-step');
      root.dataset.gwConfigStep = id;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gw-config__heading';
      const copy = document.createElement('span');
      copy.className = 'gw-config__copy';
      const title = document.createElement('span');
      title.className = 'gw-config__title';
      title.textContent = l[id];
      const summary = document.createElement('span');
      summary.className = 'gw-config__value';
      summary.id = 'gw-config-value-' + key + '-' + (++serial);
      button.setAttribute('aria-describedby', summary.id);
      copy.append(title, summary);
      button.append(copy);
      let thumbBox = null;
      if (extra.thumb) {
        thumbBox = document.createElement('span');
        thumbBox.className = 'gw-config__thumb';
        thumbBox.hidden = true;
        thumbBox.setAttribute('aria-hidden', 'true');
        button.append(thumbBox);
      }
      const action = document.createElement('span');
      action.className = 'gw-config__action';
      action.setAttribute('aria-hidden', 'true');
      const actionText = document.createElement('span');
      const chevron = document.createElement('span');
      chevron.className = 'gw-config__chev';
      action.append(actionText, chevron);
      button.append(action);
      const clip = document.createElement('div');
      clip.className = 'gw-config__clip';
      const body = document.createElement('div');
      body.className = 'gw-config__body';
      body.id = 'gw-config-body-' + key + '-' + (++serial);
      button.setAttribute('aria-controls', body.id);
      const inner = document.createElement('div');
      inner.className = 'gw-config__inner';
      nodes.forEach(node => inner.append(node));
      body.append(inner);
      clip.append(body);
      root.append(button, clip);
      const step = { id, root, button, body, inner, summary, actionText, title, thumb: thumbBox };
      steps.set(id, step);
      if (state.open[id] === undefined) state.open[id] = !!extra.open;
      button.addEventListener('click', () => {
        if (state.open[id]) collapse(step, { reason: 'heading' });
        else { expand(step, { reason: 'heading' }); reveal(step.root, 40); }
        update();
      });
      return step;
    }

    /* ------------------------------------------------ personalization step */
    const engCard = eng.querySelector('.gw-eng__card');
    eng.querySelector('.gw-eng__toggle')?.classList.add('gw-config__internal-toggle');
    const plainOption = document.createElement('label');
    plainOption.className = 'gw-config__plain-choice';
    plainChoice = document.createElement('input');
    plainChoice.type = 'radio';
    plainChoice.name = eng.querySelector('[data-gw-design]').name;
    plainChoice.dataset.gwNoEngraving = '';
    const plainCopy = document.createElement('span');
    const plainTitle = document.createElement('strong');
    const plainNote = document.createElement('small');
    text(plainTitle, l.plain_choice);
    text(plainNote, l.plain_note);
    plainCopy.append(plainTitle, plainNote);
    plainOption.append(plainChoice, plainCopy);
    eng.querySelector('.gw-eng__styles').append(plainOption);
    // Nothing pre-selected: gw-engraving ships tile 1 checked with the editor
    // off; here the customer picks a style (or no engraving) themselves.
    plainChoice.checked = false;
    if (!engravingToggle.checked) eng.querySelectorAll('[data-gw-design]:checked').forEach(radio => { radio.checked = false; });
    panel = eng.querySelector('[data-gw-placement]');
    saveWrap = eng.querySelector('[data-gw-save]');
    if (panel) {
      panelHome = document.createComment('Original engraving placement position');
      panel.before(panelHome);
    }
    const engStep = makeStep('personalization', eng, [engCard], { open: true, thumb: true });
    thumb = engStep.thumb;
    const engError = document.createElement('p');
    engError.className = 'gw-config__error';
    engError.dataset.gwConfigError = '';
    engError.setAttribute('role', 'alert');
    engError.hidden = true;
    const continueButton = document.createElement('button');
    continueButton.type = 'button';
    continueButton.className = 'gw-config__continue';
    continueButton.textContent = l.continue_size;
    engStep.inner.append(engError, continueButton);
    if (saveWrap) {
      // The email box, demoted to one line under Continue: the preview is
      // the point of the step, saving it is the side offer.
      saveLink = document.createElement('button');
      saveLink.type = 'button';
      saveLink.className = 'gw-config__save-link';
      saveLink.textContent = l.email_preview;
      saveLink.hidden = true;
      saveLink.addEventListener('click', () => { showSaveBox(true); track('save-link', 'personalization'); });
      engStep.inner.append(saveLink);
    }
    const sizeStep = { get root() { return steps.get('size')?.root; } };

    /* Unfold gw-engraving's email box. The block opens it on its own a beat
       after typing stops, or on blur of the text field; a synthetic blur is
       that same cue, for when the customer asks before the beat is over. */
    function showSaveBox(focusField) {
      if (!saveWrap) return;
      saveWanted = true;
      saveWrap.classList.add('gw-config__save-wanted');
      if (!saveWrap.classList.contains('is-open')) eng.querySelector('[data-gw-in1]')?.dispatchEvent(new Event('blur'));
      update();
      if (!focusField) return;
      const mail = eng.querySelector('[data-gw-save-mail]');
      window.setTimeout(() => {
        if (!mail || mail.disabled) return;
        mail.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'instant' : 'smooth' });
        mail.focus({ preventScroll: true });
      }, 260);
    }

    continueButton.addEventListener('click', event => {
      if (!reportEngraving()) return;
      if (!checked(eng, '[data-gw-toggle]')) {
        // Continuing with nothing picked is the "no engraving" decision.
        plainDecided = true;
        plainChoice.checked = true;
        if (event.isTrusted) restPopup();
      }
      collapse(engStep, { reason: 'continue' });
      update();
      if (sizeStep.root) glide(sizeStep.root);
      track('continue', 'personalization');
    });

    // Rule 3: "No engraving" is terminal — close on its own, show the sizes.
    plainChoice.addEventListener('change', event => {
      if (!plainChoice.checked) return;
      plainDecided = true;
      setCheckbox(engravingToggle, false);
      if (!event.isTrusted) return;
      restPopup();
      window.setTimeout(() => {
        if (!plainChoice.checked || !state.open.personalization) return;
        collapse(engStep, { reason: 'no-engraving' });
        update();
        if (sizeStep.root) glide(sizeStep.root);
      }, 350);
    });

    /* -------------------------------------------------------------- hero */
    hero = document.createElement('div');
    hero.className = 'gw-config__hero';
    plain = document.createElement('div');
    plain.className = 'gw-config__plain';
    const photo = eng.querySelector('[data-gw-board-photo="top"]');
    if (photo) {
      const img = document.createElement('img');
      img.src = photo.getAttribute('data-src') || photo.src;
      img.alt = l.plain_board;
      img.width = 1672; img.height = 941;
      img.loading = 'lazy';
      plain.append(img);
    }
    hero.append(plain);
    // The recap: one row per decision with its own price column, always
    // current, always above Add to cart. Free things say so, quietly.
    const recapWrap = document.createElement('div');
    recapWrap.className = 'gw-config__recap-wrap';
    const recap = document.createElement('table');
    recap.className = 'gw-config__recap';
    const recapBody = document.createElement('tbody');
    const recapRows = {};
    // Which rows have somewhere to go: a row whose control is not on this
    // product page (no companion offer, no gift block) stays plain text.
    const recapLive = {
      size: true, engraving: true, surface: hasGroove, feet: hasFeet,
      prep: !!extras.querySelector('[data-gw-companion-toggle]'),
      butter: !!extras.querySelector('[data-gw-butter-toggle]'),
      packaging: !!extras.querySelector('[data-gw-gift-toggle]'),
      note: !!extras.querySelector('[data-gw-gift-toggle]'),
      total: false
    };
    const PENCIL = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11.4 2.6l2 2L5.2 12.8 2.6 13.4l.6-2.6z"/><path d="M9.9 4.1l2 2"/></svg>';
    [['size', l.recap_size], ['engraving', l.recap_engraving], ['surface', l.recap_surface], ['feet', l.recap_feet],
     ['prep', l.recap_prep_label], ['butter', l.recap_butter_label], ['packaging', l.recap_packaging], ['note', l.recap_note],
     ['total', l.recap_total]].forEach(([id, label]) => {
      const tr = document.createElement('tr');
      if (id === 'total') tr.className = 'gw-config__recap-total';
      const th = document.createElement('th');
      th.scope = 'row';
      th.textContent = label;
      const td = document.createElement('td');
      const price = document.createElement('td');
      price.className = 'gw-config__recap-price';
      const edit = document.createElement('td');
      edit.className = 'gw-config__recap-edit';
      if (recapLive[id]) {
        // The whole row is the target — a finger-sized "change this" — with a
        // pencil at the end as the hint. Enter / Space work from the keyboard.
        tr.dataset.gwRecapGo = id;
        tr.tabIndex = 0;
        tr.setAttribute('role', 'button');
        const sr = document.createElement('span');
        sr.className = 'gw-config__sr';
        sr.textContent = l.change;
        edit.innerHTML = PENCIL;
        edit.append(sr);
      }
      tr.append(th, td, price, edit);
      recapBody.append(tr);
      recapRows[id] = { tr, td, price };
    });
    if (!hasGroove) recapRows.surface.tr.hidden = true;
    if (!hasFeet) recapRows.feet.tr.hidden = true;
    recap.append(recapBody);
    recapWrap.append(recap);
    hero.append(recapWrap);

    /* The recap doubles as the way back. A row opens the step that owns its
       value, glides the page there and pulses the control to change it —
       the checked tile, the text field, the switch in the extras row. */
    const recapTargets = {
      size: () => ({ step: 'size', control: tileBox(size.querySelector('[data-gw-pick]:checked')) || size.querySelector('.gw-size__grid') }),
      engraving: () => {
        const on = checked(eng, '[data-gw-toggle]');
        const custom = checked(eng, '[data-gw-custom]');
        return { step: 'personalization', control: !on ? eng.querySelector('.gw-eng__grid') : custom ? eng.querySelector('[data-gw-desc]') : eng.querySelector('[data-gw-in1]') };
      },
      surface: () => ({ step: 'details', control: tileBox(size.querySelector('[data-gw-groove]:checked')) }),
      feet: () => ({ step: 'details', control: tileBox(size.querySelector('[data-gw-feet]:checked')) }),
      prep: () => ({ control: extras.querySelector('[data-gw-companion-toggle]')?.closest('label') }),
      butter: () => ({ control: extras.querySelector('[data-gw-butter-toggle]')?.closest('label') }),
      packaging: () => ({ control: checked(extras, '[data-gw-gift-toggle]') && extras.dataset.wrapAvailable === '1' ? extras.querySelector('[data-gw-wrap-row]') : extras.querySelector('[data-gw-gift-toggle]')?.closest('label') }),
      note: () => ({ control: checked(extras, '[data-gw-gift-toggle]') ? extras.querySelector('[data-gw-msg]') : extras.querySelector('[data-gw-gift-toggle]')?.closest('label') })
    };
    function tileBox(input) { return input?.closest('label')?.querySelector('.gw-size__tile-box') || input?.closest('label') || null; }
    function flash(node) {
      if (!node) return;
      node.classList.remove('gw-config__flash');
      void node.offsetWidth;
      node.classList.add('gw-config__flash');
      const done = event => { if (!event || event.target === node) { node.classList.remove('gw-config__flash'); node.removeEventListener('animationend', done); } };
      node.addEventListener('animationend', done);
      window.setTimeout(done, 2400);
    }
    function goTo(id) {
      const target = recapTargets[id]?.();
      if (!target) return;
      const step = target.step ? steps.get(target.step) : null;
      const control = target.control && target.control.isConnected ? target.control : step?.root;
      if (!control) return;
      if (step && !state.open[step.id]) expand(step, { reason: 'recap' });
      // Stop with the step heading under the sticky header when the control
      // then fits on screen; otherwise bring the control itself to the middle.
      const top = headerBottom() + 12;
      const middle = () => Math.max(top, Math.round((window.innerHeight - control.getBoundingClientRect().height) / 2));
      let node = control, endTop = middle();
      if (step) {
        const reach = control.getBoundingClientRect().bottom - step.root.getBoundingClientRect().top;
        if (top + reach <= window.innerHeight - 24) { node = step.root; endTop = top; }
      }
      const duration = 450;
      glide(node, duration, endTop);
      window.setTimeout(() => flash(control), reducedMotion() ? 0 : duration + 40);
      track('recap', id);
    }
    recapBody.addEventListener('click', event => {
      const row = event.target.closest('tr[data-gw-recap-go]');
      if (row) goTo(row.dataset.gwRecapGo);
    });
    recapBody.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const row = event.target.closest('tr[data-gw-recap-go]');
      if (!row || event.target !== row) return;
      event.preventDefault();
      goTo(row.dataset.gwRecapGo);
    });
    // kind: '' money, 'free' (free / included), 'none' (nothing to pay for), 'total'
    function setRow(id, valueText, muted, priceText, kind) {
      const row = recapRows[id];
      text(row.td, valueText);
      row.td.classList.toggle('gw-config__recap--muted', !!muted);
      text(row.price, priceText || '');
      row.price.className = 'gw-config__recap-price' + (kind ? ' gw-config__recap-price--' + kind : '');
    }
    // gw-size paints the running total into the buy button; mirror it.
    const ctaButton = scope.querySelector('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]');
    if (ctaButton) new MutationObserver(() => schedule()).observe(ctaButton, { childList: true, characterData: true, subtree: true });
    if (panel) {
      text(panel.querySelector('.gw-eng__preview-heading'), l.preview_note);
      if (saveWrap) {
        saveButton = document.createElement('button');
        saveButton.type = 'button';
        saveButton.className = 'gw-config__save';
        saveButton.textContent = l.save_preview;
        saveButton.addEventListener('click', () => {
          expand(engStep, { reason: 'save-preview' });
          showSaveBox(true);
        });
        panel.querySelector('.gw-eng__preview-head')?.append(saveButton);
      }
      new MutationObserver(() => updateHero()).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    }
    const buyBlock = scope.querySelector('.product-info__block-item[data-block-type="payment-terms"], .product-info__block-item[data-block-type="buy-buttons"]');
    if (buyBlock) buyBlock.before(hero);
    else extras.after(hero);

    /* ------------------------------------------------ size + details steps */
    const card = size.querySelector('.gw-size__card');
    const groups = { size: [], details: [] };
    let group = 'size', section = '';
    Array.from(card.children).forEach(node => {
      if (node.matches('.gw-size__lbl--sep')) {
        group = 'details';
        const grid = node.nextElementSibling;
        section = grid?.querySelector('[data-gw-feet]') ? 'feet' : grid?.querySelector('[data-gw-groove]') ? 'groove' : '';
      }
      if (node.matches('[data-gw-err]')) return;
      // A choice that cannot reach the variant is not offered.
      if ((section === 'feet' && !hasFeet) || (section === 'groove' && !hasGroove)) { node.hidden = true; node.style.display = 'none'; }
      groups[group].push(node);
    });
    const sizeRoot = document.createElement('div');
    const detailsRoot = document.createElement('div');
    const sizeError = card.querySelector('[data-gw-err]');
    card.insertBefore(sizeRoot, sizeError);
    card.insertBefore(detailsRoot, sizeError);
    makeStep('size', sizeRoot, groups.size, { open: true });
    const detailsStep = makeStep('details', detailsRoot, groups.details, { open: true });
    if (!hasGroove || !hasFeet) text(detailsStep.title, hasGroove ? l.details_surface : hasFeet ? l.details_feet : l.details);
    if (!hasGroove && !hasFeet) { detailsRoot.hidden = true; detailsRoot.style.display = 'none'; }

    /* --------------------------------------------------------- summaries */
    function summary(id, valueText, warn) {
      const step = steps.get(id);
      text(step.summary, valueText);
      step.summary.classList.toggle('gw-config__value--warn', !!warn);
    }

    function update() {
      if (updating) return;
      updating = true;
      const on = checked(eng, '[data-gw-toggle]');
      if (!on) {
        if (plainDecided) plainChoice.checked = true;
        else eng.querySelectorAll('[data-gw-design]:checked').forEach(radio => { radio.checked = false; });
        previewAsked = false;
      } else if (plainChoice.checked) {
        plainChoice.checked = false;
        eng.querySelector('[data-gw-design]').checked = true;
      }
      const custom = checked(eng, '[data-gw-custom]');
      const design = eng.querySelector('[data-gw-design]:checked');
      const styleName = design ? l.style + ' ' + (Number(design.dataset.idx) + 1) : '';
      const typed = value(eng, '[data-gw-in1]');
      const engText = value(eng, '[data-gw-out]') || typed;
      const issue = on ? engravingIssue() : '';
      const engMessage = eng.querySelector('[data-gw-config-error]');
      if (engMessage && !issue) engMessage.hidden = true;
      // The board preview comes with the first text, on the pre-selected
      // placement — accepting that placement is what reveals it.
      if (on && !custom && typed && panel && panel.hidden && !previewAsked) {
        previewAsked = true;
        eng.querySelector('[data-gw-loc-choice]:checked')?.click();
        track('auto-preview', 'personalization');
      }
      if (saveLink) saveLink.hidden = true;   // 2026-09-12: the box itself is visible again, the one-line link is redundant
      if (!on) summary('personalization', plainDecided ? l.no_engraving : l.choose_engraving, !plainDecided);
      else if (custom) summary('personalization', value(eng, '[data-gw-desc]') ? l.custom : l.custom + ' · ' + l.describe_design, !value(eng, '[data-gw-desc]'));
      else if (!engText) summary('personalization', [styleName, l.add_text].filter(Boolean).join(' · '), true);
      else summary('personalization', [engText, styleName, value(eng, '[data-gw-loc]')].filter(Boolean).join(' · '), !!issue);
      if (!state.open.personalization) text(steps.get('personalization').actionText, actionLabel(steps.get('personalization')));

      const pick = size.querySelector('[data-gw-pick]:checked');
      if (pick) {
        const name = pick.parentElement.querySelector('em')?.textContent.trim() || '';
        const price = size.querySelector('[data-gw-price-for="' + pick.value.replace(/"/g, '\\"') + '"] [data-gw-now]')?.textContent.trim() || '';
        summary('size', [pick.value.replace(/\s*Inches/i, '″').replace(/x/g, '×'), name, price].filter(Boolean).join(' · '), false);
      } else summary('size', l.choose_size, true);

      const groove = hasGroove ? size.querySelector('[data-gw-groove]:checked') : null;
      const feet = hasFeet ? size.querySelector('[data-gw-feet]:checked') : null;
      const grooveText = groove ? (/^Without/i.test(groove.value) ? l.groove_without_short : l.groove_with_short) : '';
      const feetText = feet ? (/^Without/i.test(feet.value) ? l.feet_without_short : l.feet_with_short) : '';
      summary('details', [grooveText, feetText].filter(Boolean).join(' · '), false);

      // Recap above Add to cart
      const sizePrice = pick ? (size.querySelector('[data-gw-price-for="' + pick.value.replace(/"/g, '\\"') + '"] [data-gw-now]')?.textContent.trim() || '') : '';
      const sizeLabel = pick ? [pick.value.replace(/\s*Inches/i, '″').replace(/x/g, '×'), pick.parentElement.querySelector('em')?.textContent.trim() || ''].filter(Boolean).join(' · ') : l.choose_size;
      setRow('size', sizeLabel, !pick, sizePrice || '—', sizePrice ? '' : 'none');
      const engravingOffered = on || !plainDecided;   // nothing declined yet: the free offer stands in the recap
      setRow('engraving', steps.get('personalization').summary.textContent, !on, engravingOffered ? l.recap_free : '—', engravingOffered ? 'free' : 'none');
      setRow('surface', grooveText || '—', !grooveText, l.recap_included, 'free');
      setRow('feet', feetText || '—', !feetText, l.recap_included, 'free');
      const prepOn = checked(extras, '[data-gw-companion-toggle]');
      const prepPrice = extras.querySelector('[data-gw-companion-price]')?.textContent.trim() || '';
      const prepLabel = extras.querySelector('[data-gw-companion-subtitle]')?.textContent.trim() || extras.querySelector('[data-gw-companion-badge]')?.textContent.trim() || '';
      setRow('prep', prepOn ? prepLabel : l.recap_not_added, !prepOn, prepOn ? (prepPrice ? '+' + prepPrice : '') : '—', prepOn ? '' : 'none');
      const butterOn = checked(extras, '[data-gw-butter-toggle]');
      setRow('butter', butterOn ? l.recap_butter_value : l.recap_not_included, !butterOn, butterOn ? l.recap_free : '—', butterOn ? 'free' : 'none');
      const giftOn = checked(extras, '[data-gw-gift-toggle]');
      const wrapOn = giftOn && checked(extras, '[data-gw-wrap]') && extras.dataset.wrapAvailable === '1';
      const wrapPrice = extras.querySelector('[data-gw-wrap-row] .gw-gift__price')?.textContent.trim() || '';
      setRow('packaging', wrapOn ? l.recap_wrap : l.recap_no_wrap, !wrapOn, wrapOn ? (wrapPrice ? '+' + wrapPrice : '') : '—', wrapOn ? '' : 'none');
      const message = giftOn ? value(extras, '[data-gw-msg]') : '';
      const from = giftOn ? value(extras, '[data-gw-from]') : '';
      const to = giftOn ? value(extras, '[data-gw-to]') : '';
      let noteText = '';
      if (message) noteText = '“' + (message.length > 60 ? message.slice(0, 57).trim() + '…' : message) + '”';
      else if (from || to) noteText = [from ? l.recap_from + ' ' + from : '', to ? l.recap_to + ' ' + to : ''].filter(Boolean).join(' · ');
      setRow('note', noteText || l.recap_no_note, !noteText, noteText ? l.recap_free : '—', noteText ? 'free' : 'none');
      const total = scope.querySelector('form[action*="/cart/add"] .gw-cta-amt')?.textContent.trim() || sizePrice;
      setRow('total', '', false, total, 'total');

      updateThumb();
      updateHero();
      updating = false;
    }

    function schedule() { window.clearTimeout(queued); queued = window.setTimeout(update, 0); }

    /* ---------------------------------------------------------- listeners */
    scope.addEventListener('input', event => { if (event.isTrusted) touch(); schedule(); });
    scope.addEventListener('change', event => { if (event.isTrusted) touch(); schedule(); });
    window.addEventListener('resize', schedule);
    // Rule 1 — real pointer/keyboard interactions only (scripts click radios too).
    scope.addEventListener('click', event => { if (event.isTrusted) { touch(); moveOn(event.target); } }, true);
    scope.addEventListener('focusin', event => { if (event.isTrusted) { touch(); moveOn(event.target); } }, true);
    // Add to cart with a problem in a collapsed step: open it before the
    // block's own validation shows its message.
    scope.addEventListener('invalid', event => {
      const step = stepOf(event.target);
      if (step && !state.open[step.id]) expand(step, { instant: true, reason: 'invalid' });
    }, true);
    scope.addEventListener('submit', () => {
      if (engravingIssue() && !state.open.personalization) { expand(engStep, { instant: true, reason: 'submit' }); update(); }
    }, true);
    ['gw:size', 'gw:engraving', 'gw:gift', 'gw:addons', 'gw:butter', 'variant:change'].forEach(name => document.addEventListener(name, schedule));

    /* ------------------------------------------------------------ boot */
    steps.forEach(step => {
      step.root.classList.add('gw-config-step--instant');
      apply(step, !!state.open[step.id]);
      void step.root.offsetHeight;
    });
    requestAnimationFrame(() => steps.forEach(step => step.root.classList.remove('gw-config-step--instant')));
    update();
    track('ready', 'configurator');
  }

  function scan() {
    document.querySelectorAll('[data-gw-configurator-settings]').forEach(settings => {
      try { init(settings); } catch (error) { console.error('[gw-configurator]', error); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  ['shopify:section:load', 'product:rerender'].forEach(name => document.addEventListener(name, () => window.setTimeout(scan, 0)));
})();
  } catch(e) { console.error(e); }
})();

})();
